<template>
  <div>
    <v-layout column ma-1>
      <v-flex>
        <v-card :class="timerSectionClass">
          <v-flex pa-2>
            <v-layout row title>
              <mrx-translation :token="'questions.malaria.child_test_id'"></mrx-translation> &nbsp; <v-flex font-weight-bold>{{ childTestId }}</v-flex>
            </v-layout>
          </v-flex>
          <v-layout row>
            <v-flex>
                <v-layout column align-center>
                  <v-btn @click="startTimer" :disabled="!!timer.startTime">
                    <mrx-translation :token="timerButtonDisplay"></mrx-translation>
                  </v-btn>
                  <v-btn v-if="showSkipTest" @click="skipTest">
                    <mrx-translation :token="'questions.malaria_rdt_result.skip_test'"></mrx-translation>
                  </v-btn>
                </v-layout>
            </v-flex>
            <v-flex>
              <v-layout column align-center headline>
                <h2 :class="timer.startTime ? '' : 'grey--text text--lighten-1'">
                  {{ timer.elapsedDisplay }}
                </h2>
                <v-btn v-if="showRetakeTest" @click="retakeTest">
                    <mrx-translation :token="'questions.malaria_rdt_result.retake_test'"></mrx-translation>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout class="ma-2">
      <h3 class="mt-3">
        <mrx-translation :token="'questions.malaria_rdt_result.select_result'"></mrx-translation>
      </h3>
    </v-layout>
    
    <component
        v-bind:is="'MultiSelect'"
        v-bind:options="{'template':'rectangle'}"
        v-bind:panelType="'select'"
        v-model="responsesShown"
        v-bind:languagePath="languagePath"
        v-bind:disabled="!timer.allowSelection">
      </component>
      
   
</div>
</template>

<script>
  import MultiSelect from '@/components/inputs/MultiSelect'

  export default {
    name: 'MalariaRdtResult',
    components: { MultiSelect },
    model: {
      prop: 'items',
      event: 'click'
    },
    props: {
      'options': Object,
      'items': Array,
      'panelName': String,
      'languagePath': String
    },
    data() {
      return {
        childTestId: null,
        timer: {
          startTime: null,
          elapsedDisplay: '00:00',
          allowSelectionStart: 900000,
          allowSelectionEnd: 1200000,
          allowSelection: false
        },
        showRetakeTest: false,
        showSkipTest: false,
        timerSectionClass: {
          'white-imp': true
        }
      }
    },
    computed: {
      timerButtonDisplay() {
        let token = 'questions.malaria_rdt_result.start_timer'
        return token
      },
      responsesShown() {
        return this.items.filter(i => {
          return i.value !== 'timed_out'
        })
      }
    },
    created() {
      this.childTestId = this.$store.state.settings.malaria_rdt_random_num
      this.items.forEach(item => {
        item.rdt_test_id = this.options.rdt_test_id
      })
      if (this.$store.getters['v4/mode/get']('testing')) {
        this.timer.allowSelectionStart = 5000
        this.timer.allowSelectionEnd = 20000
      }
      else if (this.options.timer) {
        this.timer.allowSelectionStart = this.options.timer.allowSelectionStart
        this.timer.allowSelectionEnd = this.options.timer.allowSelectionEnd
      }
    },
    methods: {
      startTimer() {
        if (!this.timer.startTime) {
          this.timer.startTime = Date.now()
          this.timerTick()
          this.items.forEach(i => {
            i.selected = false
          })
        }
      },
      timerTick() {
        if (this.timer.startTime) {
          let seconds = Math.floor((Date.now() - this.timer.startTime) / 1000)
          let minutes = Math.floor(seconds / 60)
          seconds = seconds % 60
          seconds = seconds < 10 ? `0${seconds}` : `${seconds}`
          minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
          this.timer.elapsedDisplay = `${minutes}:${seconds}`
          if (Date.now() - this.timer.startTime >= this.timer.allowSelectionEnd) {
            if (this.timer.allowSelection) {
              let selectionEntered = false
              this.items.slice(0, 5).forEach(i => {
                if (i.selected) {
                  selectionEntered = true
                }
              })
              if (!selectionEntered) {
                this.showRetakeTest = true
                this.showSkipTest = true
                this.timerSectionClass = {
                  'warning': true
                }
              }
              else if (this.items[4].selected) {
                this.showRetakeTest = true
                this.timerSectionClass = {
                  'warning': true
                }
              }
              this.timer.allowSelection = false
            }
          }
          else if (Date.now() - this.timer.startTime >= this.timer.allowSelectionStart) {
            this.timer.allowSelection = true
            this.timerSectionClass = {
              'success': true
            }
            setTimeout(this.timerTick, 1000)
          }
          else {
            setTimeout(this.timerTick, 1000)
          }
        }
      },
      retakeTest() {
        this.timer.startTime = null
        this.timer.elapsedDisplay = '00:00'
        this.showRetakeTest = false
        this.items.forEach(i => {
          i.selected = false
        })
        this.showSkipTest = false
        this.timerSectionClass = {
          'white-imp': true
        }
        this.childTestId = this.generateChildTestId()
        this.$store.state.settings.malaria_rdt_random_num = this.childTestId
      },
      skipTest() {
        this.items[4].selected = true
      }
    }
  }
</script>

<style scoped>
  button {
    width: 8rem;
  }

  .white-imp {
    background-color: white !important;
  }

  .timer-section {
    min-height: 11.5rem;
  }

  .forced-half-width {
    max-width: 50%;
  }

  .option-header-img {
    min-height: 6rem;
  }

  .option-card-img {
    min-height: 15rem;
  }

  .option-card-no-img {
    max-height: 9rem;
  }

  .option-img {
    width: 100%;
  }

  .greyed-out {
    background-color: #BDBDBD !important
  }
</style>
